module.exports = __webpack_public_path__ + "img/bcis_logo.e8bf88eb.jpg";